import {Question} from '@/state/models/Question';

export class Test {
    public assessmentId: number = 0;
    public title: string = '';
    public headline: string = '';
    public questions: {id: number}[] = [];

    constructor(id: number, title: string, description: string, questions: {id: number}[]) {
        this.assessmentId = id;
        this.title = title;
        this.headline = description;
        this.questions = questions;
    }
}
